import { SlotGameType1_21 } from '../SlotGameType1_21';

export class LuckyFire4021 extends SlotGameType1_21
{
}
